/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SignedInputs */

const en_common_signed = /** @type {(inputs: Common_SignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed`)
};

/**
* | output |
* | --- |
* | "Signed" |
*
* @param {Common_SignedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_signed = /** @type {((inputs?: Common_SignedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SignedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_signed(inputs)
});